const common = {
  'Something went wrong. Please try again.':
    'エラーが発生しました。もう一度お試しください',
  Confirm: '確認',
  Cancel: 'キャンセル',
  Close: '閉じる',
  Save: '保存',
  Logout: 'ログアウト',
  'Upgrade now': 'ワンクリックでアップグレード',
};

export default common;
